import { map } from 'lodash';

import { HHAxiosRequest } from '../network';
import * as ActionTypes from './types';
import * as API from '../network/api';
import { hlog } from '../common/util';

const normalizeUserNotification = (userNotification) => ({
  ...userNotification.notification,
  _id: userNotification._id || null,
  notificationId: userNotification.notification._id || null,
  read: userNotification.read || false,
  deleted: userNotification.deleted || false
});

export const retrieveNotifications = (requestBody) => async (dispatch) => {
  try {
    const res = await HHAxiosRequest(API.NOTIFICATION_RETRIEVE, requestBody);
    if (res && res.data) {
      const { ok, notifications } = res.data;
      if (ok) {
        dispatch({
          type: ActionTypes.RETRIEVE_NOTIFICATIONS,
          payload: map(notifications, normalizeUserNotification)
        });
      }
    } else {
      hlog('error: retrieving notifications');
    }
  } catch (err) {
    hlog(err);
  }
};

export const updateNotification = (_id, data, token) => async (dispatch) => {
  try {
    const res = await HHAxiosRequest(
      API.NOTIFICATION_UPDATE,
      { _id, data, token }
    );


    if (res && res.data) {
      // dispatch here
      const { notification, ok } = res.data;
      const payload = normalizeUserNotification(notification);

      if (ok) {
        dispatch({
          type: ActionTypes.UPDATE_NOTIFICATION,
          payload
        });
      }
    } else {
      hlog('error: update notifications');
    }
  } catch (err) {
    hlog(err);
  }
};

export const deleteNotification = (_id, token) => async (dispatch) => {
  try {
    const res = await HHAxiosRequest(API.NOTIFICATION_DELETE, { _id, token });

    if (res && res.data) {
      // dispatch here
      const { notification, ok } = res.data;
      if (ok) {
        dispatch({
          type: ActionTypes.DELETE_NOTIFICATION,
          payload: normalizeUserNotification(notification)._id
        });
      }
    } else {
      hlog('error: delete notifications');
    }
  } catch (err) {
    hlog(err);
  }
};

export const deleteAllNotifications = () => async (dispatch, getState) => {
  try {
    const { token } = getState().user;
    const res = await HHAxiosRequest(API.NOTIFICATION_DELETE_ALL, { token });

    if (res && res.data) {
      const { ok } = res.data;
      if (ok) { dispatch({ type: ActionTypes.DELETE_ALL_NOTIFICATION }); }
    } else {
      hlog('error: delete notifications');
    }
  } catch (err) {
    hlog(err);
  }
};

export const receiveNewNotification = (notification) => (dispatch) => {
  const payload = normalizeUserNotification(notification);
  dispatch({
    type: ActionTypes.RECEIVE_NEW_NOTIFICATION,
    payload
  });
};



// WEBPACK FOOTER //
// ./src/components/actions/notification.js